import { useContext } from 'react';
import OnboardingContext from '../context/onboardingContext';

const useOnboardingTour = () => {
  const ctx = useContext(OnboardingContext);
  if (!ctx) {
    throw new Error('useOnboardingTour must be used within OnboardingProvider');
  }
  return ctx;
};

export default useOnboardingTour;
